/* eslint-disable array-callback-return */
/* eslint-disable linebreak-style */
/* eslint-disable no-console */
const prefix = '[FB Pixel]';

export function init(codes) {
  codes.filter((v) => !v.name || v.name === 'fbPixel').map((v) => {
    console.log(`${prefix} Init triggered for ${v.codeId || v}`);
  });
}

export function pageview() {
  console.log(`${prefix} Pageview triggered for ${window.location.pathname
  + window.location.search}`);
}

export function event(name = '', data = {}) {
  console.log(`${prefix} Event for ${name} triggered, with data ${JSON.stringify(data)}`);
}

export function exception(description = '', fatal = false) {
  console.log(
    `${prefix} ${
      fatal ? 'Fatal exception' : 'Exception'
    } with description ${description}`
  );
}

export function trackSingleCustom(code, name, data = {}) {
  console.log(`${prefix} Event trackSingleCustom for ${name}/${code} triggered, with data ${JSON.stringify(data)}`);
}
